import home from './views/home';

export default [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/rule',
    name: 'rule',
    component: () => import('./views/rule.vue'),
    meta: {
      title: '活动规则'
    }
  }
];
